"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.search.placeholder': 'Szukaj poradników...',
};
